import React, { useEffect, useState } from 'react';

// Stylesheet import
import classes from './ShortsInteraction.module.css';

// Icon import from Feather icon
import { Clock as Time, Bookmark, MessageSquare as Discuss, Paperclip as Attachments, Share2, Send } from 'react-feather';

// Reactions component import
import TVCardReactions from '../../TVPage/TVCard/TVCardReactions/TVCardReactions.js';

// useDispatch hook import
import { useDispatch, useSelector } from 'react-redux';


import CopyLinkModal from '../../TVPage/TVCard/TVCardInteraction/CopyLinkModal/CopyLinkModal.js';
import GoToSignInModal from '../../CommonComponents/GoToSignInModal/GoToSignInModal.js';

import AttachmentDownloadModal from '../../TVPage/TVCard/TVCardInteraction/AttachmentDownloadModal/AttachmentDownloadModal.js';
import API from "../../../Axios/axios.js";
import { useNavigate } from "react-router-dom";
// flutter web view context to detect when web is running on flutter webview
import { useFlutterWebView } from '../../../Context/FlutterWebView/FlutterWebViewContext.js';
import { sendEventToFlutter } from '../../../HelperFunctions/flutterMobile.js';
import { flutterEvents } from '../../../Constants/flutterEvents.js';
import { savePost, UnSavePost } from '../../../Store/userProfileSlice.js';
import ShortsDiscussionPanel from './ShortsDiscussionPanel.js';
import { discussionDataGet } from '../../../Store/TVPagePostsSlice.js';

// boolean value to detect flutter webview
function ShortsInteraction({ postData, postType }) {
  const isFlutterWebView = useFlutterWebView();
  // Destructuring postData props
  const {
    id,
    created_at,
    reaction_score: { total_score },
    comment: { list_url, total, isOpenDiscussPanel, create_url },
    file_attachments_count
  } = postData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openAttachmentDownloadModal, setOpenAttachmentDownloadModal] = useState(false);
  const [isDiscussionPanelOpen, setIsDiscussionPanelOpen] = useState(false);
  const [isCopyLinkModal, setIsCopyLinkModal] = useState(false);
  const [goToSignInModal, setGoToSignInModal] = useState(false);
  const [attachmentModalData, setAttachmentModalData] = useState(false);
  const token = localStorage.getItem('token');
  const [isSaved, setIsSaved] = useState(false);

  const copyButtonClickHandler = async () => {
    setIsCopyLinkModal(true);
    // This will copy the link to the clipboard
    const link = `${window.location.origin}/post/${id}`;
    try {
      if (isFlutterWebView) {
        sendEventToFlutter(flutterEvents.COPY_TEXT(link));
      } else {
        await navigator.clipboard.writeText(link);
      }
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
  const discussIconClickHandler = async (postId) => {
    if (localStorage.getItem('token')) {

      if (isOpenDiscussPanel) {
        // It will close the discussion panel only if it is open
        setIsDiscussionPanelOpen(false)
      } else {
        // This will get the discussion data from the API server and after that open the discussion panel
        dispatch(discussionDataGet(list_url))
          .then(() => {
            setIsDiscussionPanelOpen(true)
            window.scrollTo({
              top: document.documentElement.scrollHeight, behavior: 'smooth',
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }

    } else {
      setGoToSignInModal(true);
    }
  };
  // save post
  const savePostClickHandler = async () => {
    if (token) {
      try {
        const response = await API.post(
          `/posts/${id}/saved`,
          {},
          {
            headers: {
              Authorization: `token ${token}`,
            },
          }
        );
        console.log(response.data);
        setIsSaved(!isSaved);
        if (isSaved) {
          dispatch(UnSavePost(response.data.message.post.id));
        } else {
          dispatch(savePost(response.data.message));
        }
      } catch (e) {
        if (e.response.data.message === 'Invalid token.') {
          localStorage.removeItem('token');
          navigate('/entry/signin');
        }
      }
    } else {
      navigate('/entry/signin');
    }
  };
  // fetcch post analysis for this user
  const fetchPostAnalysis = async () => {
    if (token) {
      try {
        const response = await API.get(`/posts/${id}/dropdown`, {
          headers: {
            Authorization: `token ${token}`,
          },
        });
        if (response.data.saved === true) {
          setIsSaved(true);
        } else if (response.data.saved === false) {
          setIsSaved(false);
        }

      } catch (e) {
        if (e.response.data.message === 'Invalid token.') {
          localStorage.removeItem('token');
          navigate('/entry/signin');
        }
      }
    } else {
    }
  };

  useEffect(() => {
    fetchPostAnalysis()
  }, [])
  return (<>
    {goToSignInModal && (<GoToSignInModal setGoToSignInModal={setGoToSignInModal} />)}
    {isCopyLinkModal && (<CopyLinkModal setIsCopyLinkModal={setIsCopyLinkModal} text={`Link copied.`} />)}
    {openAttachmentDownloadModal && (<AttachmentDownloadModal
      setOpenAttachmentDownloadModal={setOpenAttachmentDownloadModal}
      attachmentModalData={attachmentModalData}
    />)}

    {isDiscussionPanelOpen && (
      <ShortsDiscussionPanel postData={postData} onClose={() => setIsDiscussionPanelOpen(false)} />
    )}
    <div className={classes.interactions}>
      <TVCardReactions isShorts postData={postData} postType={postType} />

      <div className={classes.actionBtn} onClick={() => discussIconClickHandler(id)} >

        <Discuss
          className={classes.actionIcon}

        />
        <span>{total}</span>
      </div>
      <div className={classes.actionBtn} onClick={copyButtonClickHandler}>
        <Share2
          className={classes.actionIcon}

        />
        <span>0</span>
      </div>

      <div className={classes.actionBtn} onClick={savePostClickHandler}>
        <Bookmark className={`${isSaved ? classes.saved : ''} ${classes.actionIcon}`} />

        <span>0</span>

      </div>

    </div>
  </>);
}

export default ShortsInteraction;
